import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FormLanguagesService {
    current$ = new BehaviorSubject(null);

    reset(): void {
        this.current$.next('pl');
    }
}
